import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentChatPromptSent.meta';

export type AgentChatPromptSource = 'canvas_toolbar' | 'edit_in_canvas' | 'empty_state' | 'sidebar';

export type UseTrackAgentChatPromptSentParams = {
  message_length: number;
  canvas_id: string;
  thread_id: string;
  source: AgentChatPromptSource;
  slash_commands: string[];
};

export const useTrackAgentChatPromptSent = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentChatPromptSent = useCallback(
    (params: UseTrackAgentChatPromptSentParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAgentChatPromptSent };
};
